import { Environment } from '../environment';
import throttle from 'lodash/throttle';
import { createStore$ } from '../createStore$';

const idle$ = createStore$<boolean>({ initialState: false });
const SECONDS_IDLE = Environment.IS_DEV ? 5 : 30;
let timeout;
let nodes: Node[] = [];
const resetStateThrottled = throttle(resetState, 500);

document.addEventListener('scroll', resetStateThrottled);
document.addEventListener('click', resetStateThrottled);
document.addEventListener('touchstart', resetStateThrottled);
document.addEventListener('mousedown', resetStateThrottled);

(window as any).isIdle = () => idle$.getValue();

resetState();

export namespace Idle$ {
    export const useValue = idle$.useValue;

    export function isIdle() {
        return idle$.getValue();
    }

    export function reset() {
        resetState();
    }
}

function resetState() {
    window.clearTimeout(timeout);

    if (idle$.getValue()) {
        idle$.setValue(false);
    }

    timeout = setTimeout(() => {
        if (!idle$.getValue()) {
            idle$.setValue(true);
        }
    }, SECONDS_IDLE * 1000);
}

module?.hot?.dispose?.(() => {
    window.clearTimeout(timeout);
    document.removeEventListener('click', resetStateThrottled);
    document.removeEventListener('scroll', resetStateThrottled);

    nodes.forEach((node) => {
        node.removeEventListener?.('scroll', resetStateThrottled);
    });

    nodes = [];
});
